import { defineStore } from "pinia";
const MESSAGE_DEFAULT_TIMEOUT = 5;
let cpt = 0;
const useToastsStore = defineStore("uikit-toasts", {
  state: () => ({
    toasts: []
  }),
  actions: {
    success(message) {
      this._pushToast("success", message);
    },
    warning(message) {
      this._pushToast("warning", message);
    },
    error(message) {
      this._pushToast("error", message);
    },
    info(message) {
      this._pushToast("info", message);
    },
    _pushToast(type, message) {
      this.toasts.push({
        id: `${cpt++}`,
        type,
        message,
        timeout: MESSAGE_DEFAULT_TIMEOUT
      });
    },
    clearToast(id) {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
    }
  },
  getters: {
    hasToasts: (state) => {
      return state.toasts.length > 0;
    }
  }
});
export {
  useToastsStore
};
//# sourceMappingURL=toasts.es.js.map
